import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import OrganInstalmentConditoin from "./OrganInstalmentConditoin"
import AddIcon from "@material-ui/icons/Add"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

const optionInstalmentDate = [
      { value: "0", label: "نقد" },
      { value: "1", label: "یک ماه بعد" },
      { value: "2", label: "دو ماه بعد" },
      { value: "3", label: "سه ماه بعد" },
      { value: "4", label: "چهار ماه بعد" },
      { value: "5", label: "پنج ماه بعد" },
      { value: "6", label: "شش ماه بعد" },
      { value: "7", label: "هفت ماه بعد" },
      { value: "8", label: "هشت ماه بعد" },
      { value: "9", label: "نه ماه بعد" },
      { value: "10", label: "ده ماه بعد" },
      { value: "11", label: "یازده ماه بعد" },
]

class ChangeOrganContrat extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  organ_contract_id: "",
                  organ_contract_num: "",
                  organ_contract_clearing_day: "",
                  organ_contract_discount_max_amount: "",
                  organ_contract_discount_amount: "",
                  organ_contract_discount_percent: "",
                  organ_contract_date: "",
                  organ_contract_date_start: "",
                  organ_contract_date_end: "",
                  selectedOrgan: "",
                  selectedFilterOrgan: "",
                  selectedFieldinsurance: "",
                  selectedFilterFieldinsurance: "",
                  selectedInstamentRoundMode: "",
                  selectedCompany: "",
                  selectedFilterCompany: "",
                  organ_contract_deactive: "0",
                  organ_contract_editable: "1",
                  company_logo_url: "",
                  fieldinsurance_logo_url: "",
                  organ_logo: "",
                  orderBy: "organ_contract_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newContract: true,
                  optionCompany: [],
                  optionFilterCompany: [],
                  optionInstamentRoundMode: [],
                  optionFilterFieldinsurance: [],
                  optionOrgan: [],
                  optionFilterOrgan: [],
                  openDialog: false,
                  installmentCondition: [],
                  instalment_conditions_percent: "",
                  instalment_conditions_desc: "",
                  selectedContractDate: "",
                  selectedContractMode: "",
                  optionInstalmentMode: [],
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleChangeContractNum = (event) => {
            this.setState({ organ_contract_num: event.target.value })
      }
      handleChangeDayClear = (event) => {
            this.setState({ organ_contract_clearing_day: event.target.value })
      }
      handleChangeDiscMax = (event) => {
            this.setState({ organ_contract_discount_max_amount: event.target.value })
      }
      handleChangeDiscAmount = (event) => {
            this.setState({ organ_contract_discount_amount: event.target.value })
      }

      handleChangePercent = (event) => {
            this.setState({ organ_contract_discount_percent: event.target.value })
      }
      setSelectedDay = (event) => {
            this.setState({ organ_contract_date: event }, () => {})
      }

      setSelectedDayStart = (event) => {
            this.setState({ organ_contract_date_start: event }, () => {})
      }

      setSelectedDayEnd = (event) => {
            console.log(event)
            this.setState({ organ_contract_date_end: event }, () => {})
      }
      clearDey = (event) => {
            this.setState({ organ_contract_date: "" }, () => {})
      }
      clearDeyStart = (event) => {
            this.setState({ organ_contract_date_start: "" }, () => {})
      }
      clearDeyEnd = (event) => {
            this.setState({ organ_contract_date_end: "" }, () => {})
      }

      handleInstamentRoundMode = (selectedInstamentRoundMode) => {
            this.setState({ selectedInstamentRoundMode: selectedInstamentRoundMode })
      }

      handleFieldinsurance = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance, fieldinsurance_logo_url: selectedFieldinsurance.logo })
      }

      handleFilterFieldinsurance = (selectedFilterFieldinsurance) => {
            this.setState({ selectedFilterFieldinsurance: selectedFilterFieldinsurance }, () => {
                  this.filterContract()
            })
      }

      handleOrgan = (selectedOrgan) => {
            this.setState({ selectedOrgan: selectedOrgan, organ_logo: selectedOrgan.logo })
      }

      handleFilterOrgan = (selectedFilterOrgan) => {
            this.setState({ selectedFilterOrgan: selectedFilterOrgan }, () => {
                  this.filterContract()
            })
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany, company_logo_url: selectedCompany.logo })
      }

      handleFilterCompany = (selectedFilterCompany) => {
            this.setState({ selectedFilterCompany: selectedFilterCompany }, () => {
                  this.filterContract()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ organ_contract_deactive: "0" })
            } else {
                  this.setState({ organ_contract_deactive: "1" })
            }
      }

      handleChangeEditable = (event) => {
            if (event.target.checked) {
                  this.setState({ organ_contract_editable: "1" })
            } else {
                  this.setState({ organ_contract_editable: "0" })
            }
      }

      handleContractMode = (selectedContractMode) => {
            this.setState({ selectedContractMode: selectedContractMode })
      }

      handleContractDate = (selectedContractDate) => {
            this.setState({ selectedContractDate: selectedContractDate })
      }
      handleChangeConditionsPercent = (event) => {
            this.setState({ instalment_conditions_percent: event.target.value })
      }

      handleChangeConditionsDesc = (event) => {
            this.setState({ instalment_conditions_desc: event.target.value })
      }

      handleSelectRows = (row2) => {
            var jdate = "",
                  jdate1 = "",
                  jdate2 = ""
            if (row2.organ_contract_date !== "") {
                  var varmoment = Moment(row2.organ_contract_date, "YYYY-M-D HH:mm:ss")
                  var date = new Date(parseInt(varmoment.format("x")))
                  jdate = new JDate(date)
                  jdate = { day: parseInt(jdate.format("DD")), month: parseInt(jdate.format("MM")), year: parseInt(jdate.format("YYYY")) }
            }

            if (row2.organ_contract_date !== "") {
                  var varmoment1 = Moment(row2.organ_contract_date_start, "YYYY-M-D HH:mm:ss")
                  var date1 = new Date(parseInt(varmoment1.format("x")))
                  jdate1 = new JDate(date1)
                  jdate1 = { day: parseInt(jdate1.format("DD")), month: parseInt(jdate1.format("MM")), year: parseInt(jdate1.format("YYYY")) }
            }
            if (row2.organ_contract_date_end !== "") {
                  var varmoment2 = Moment(row2.organ_contract_date_end, "YYYY-M-D HH:mm:ss")
                  var date2 = new Date(parseInt(varmoment2.format("x")))
                  var jdate2 = new JDate(date2)
                  jdate2 = { day: parseInt(jdate2.format("DD")), month: parseInt(jdate2.format("MM")), year: parseInt(jdate2.format("YYYY")) }
            }

            this.getContractCondition(row2.organ_contract_id)
            this.setState(
                  {
                        organ_contract_id: row2.organ_contract_id,
                        organ_contract_num: row2.organ_contract_num,
                        organ_contract_clearing_day: row2.organ_contract_clearing_day,
                        organ_contract_discount_max_amount: row2.organ_contract_discount_max_amount,
                        organ_contract_discount_amount: row2.organ_contract_discount_amount,
                        organ_contract_discount_percent: row2.organ_contract_discount_percent,
                        organ_contract_date: jdate,
                        organ_contract_date_start: jdate1,
                        organ_contract_date_end: jdate2,
                        selectedFieldinsurance: {
                              value: row2.organ_contract_fieldinsuranc_id,
                              label: row2.fieldinsurance_fa,
                              logo: row2.fieldinsurance_logo_url,
                        },
                        selectedInstamentRoundMode: { value: row2.organ_contract_instalment_round_id, label: row2.instalment_round_name },
                        selectedOrgan: { value: row2.organ_contract_organ_id, label: row2.organ_name, logo: row2.organ_logo },
                        selectedCompany: { value: row2.organ_contract_company_id, label: row2.company_name, logo: row2.company_logo_url },

                        organ_contract_deactive: row2.organ_contract_deactive,
                        organ_contract_editable: row2.organ_contract_editable,
                        company_logo_url: row2.company_logo_url,
                        organ_logo: row2.organ_logo,
                        fieldinsurance_logo_url: row2.fieldinsurance_logo_url,
                        newContract: false,
                  },
                  () => {}
            )
      }

      newContract = (event) => {
            this.setState({
                  organ_contract_id: "",
                  organ_contract_num: "",
                  organ_contract_clearing_day: "",
                  organ_contract_discount_max_amount: "",
                  organ_contract_discount_amount: "",
                  organ_contract_discount_percent: "",
                  organ_contract_date: "",
                  organ_contract_date_start: "",
                  organ_contract_date_end: "",
                  selectedInstamentRoundMode: "",
                  selectedFieldinsurance: "",
                  selectedOrgan: "",
                  selectedCompany: "",
                  organ_contract_deactive: "0",
                  organ_contract_editable: "1",
                  company_logo_url: "",
                  fieldinsurance_logo_url: "",
                  organ_logo: "",
                  newContract: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getContract()
                                    self.getoptionCompany()
                                    self.getoptionInstamentRoundMode()
                                    self.getoptionFieldinsurance()
                                    self.getoptionOrgan()
                                    self.getoptionInstalmentMode()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deleteManagdiscount = () => {
            const { organ_contract_id } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getContract()
                              self.newContract()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_organ_contract")
            fd.append("organ_contract_id", organ_contract_id)

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getContract() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_contract")
            fd.append("organ_id", "2")

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getContractCondition(organ_contract_id) {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ installmentCondition: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_contract_instalment")
            fd.append("instalment_condition_contract_id", organ_contract_id)

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionInstalmentMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].instalment_mode_mode_id, label: arr.data[k].instalment_mode_mode_name })
                              }
                              self.setState({ optionInstalmentMode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_instalment_mode")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه شرکت های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                                    Company1.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, optionFilterCompany: Company1, selectedFilterCompany: Company1[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.send(fd)
      }

      getoptionInstamentRoundMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].instalment_round_id, label: arr.data[k].instalment_round_name })
                              }
                              self.setState({ optionInstamentRoundMode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_instalment_mode_round")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.send(fd)
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه رشته های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                                    Company1.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                              }
                              self.setState(
                                    {
                                          optionFieldinsurance: Company,
                                          optionFilterFieldinsurance: Company1,
                                          selectedFilterFieldinsurance: Company1[0],
                                    },
                                    () => {}
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }

      getoptionOrgan = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه ارگان ها ", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].organ_id, label: arr.data[k].organ_name, logo: arr.data[k].organ_logo })
                                    Company1.push({ value: arr.data[k].organ_id, label: arr.data[k].organ_name, logo: arr.data[k].organ_logo })
                              }
                              self.setState({ optionOrgan: Company, optionFilterOrgan: Company1, selectedFilterOrgan: Company1[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_organ")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewContract = () => {
            const {
                  organ_contract_num,
                  organ_contract_clearing_day,
                  organ_contract_discount_max_amount,
                  organ_contract_discount_amount,
                  organ_contract_discount_percent,
                  organ_contract_date,
                  organ_contract_date_start,
                  organ_contract_date_end,
                  selectedInstamentRoundMode,
                  selectedFieldinsurance,
                  selectedOrgan,
                  selectedCompany,
                  organ_contract_deactive,
                  organ_contract_editable,
            } = this.state
            if (
                  selectedInstamentRoundMode != "" &&
                  selectedFieldinsurance != "" &&
                  selectedOrgan != "" &&
                  selectedCompany != "" &&
                  organ_contract_num != "" &&
                  organ_contract_clearing_day != "" &&
                  organ_contract_discount_max_amount != "" &&
                  organ_contract_discount_amount != "" &&
                  organ_contract_discount_percent != ""
            ) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.newContract()
                                    self.getContract()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_contract")
                  fd.append("organ_contract_num", organ_contract_num)
                  fd.append("organ_contract_clearing_day", organ_contract_clearing_day)
                  fd.append("organ_contract_discount_max_amount", organ_contract_discount_max_amount)
                  fd.append("organ_contract_discount_amount", organ_contract_discount_amount)
                  fd.append("organ_contract_discount_percent", organ_contract_discount_percent)
                  if (organ_contract_date === "") {
                        fd.append("organ_contract_date", "")
                  } else {
                        fd.append(
                              "organ_contract_date",
                              Moment(JDate.toGregorian(organ_contract_date.year, organ_contract_date.month, organ_contract_date.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  if (organ_contract_date_start === "") {
                        fd.append("organ_contract_date_start", "")
                  } else {
                        fd.append(
                              "organ_contract_date_start",
                              Moment(
                                    JDate.toGregorian(organ_contract_date_start.year, organ_contract_date_start.month, organ_contract_date_start.day)
                              ).format("YYYY-MM-DD h:mm:ss")
                        )
                  }

                  if (organ_contract_date_end === "") {
                        fd.append("organ_contract_date_end", "")
                  } else {
                        fd.append(
                              "organ_contract_date_end",
                              Moment(
                                    JDate.toGregorian(organ_contract_date_end.year, organ_contract_date_end.month, organ_contract_date_end.day)
                              ).format("YYYY-MM-DD h:mm:ss")
                        )
                  }
                  fd.append("organ_contract_file_id", "0")
                  fd.append("organ_contract_instalment_round_id", selectedInstamentRoundMode.value)
                  fd.append("organ_contract_fieldinsuranc_id", selectedFieldinsurance.value)
                  fd.append("organ_contract_organ_id", selectedOrgan.value)
                  fd.append("organ_contract_company_id", selectedCompany.value)
                  fd.append("organ_contract_deactive", organ_contract_deactive)
                  fd.append("organ_contract_editable", organ_contract_editable)

                  xhttp.open("POST", `${constants.BASE_URL}/organ`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewContractCondition = () => {
            const {
                  organ_contract_id,
                  selectedContractDate,
                  selectedContractMode,
                  instalment_conditions_percent,
                  instalment_conditions_desc,
            } = this.state
            if (selectedContractDate != "" && selectedContractMode != "" && instalment_conditions_percent != "" && instalment_conditions_desc != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({
                                          instalment_conditions_percent: "",
                                          instalment_conditions_desc: "",
                                          selectedContractDate: "",
                                          selectedContractMode: "",
                                    })
                                    self.getContractCondition(organ_contract_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_contract_instalment")
                  fd.append("instalment_condition_contract_id", organ_contract_id)
                  fd.append("instalment_conditions_percent", instalment_conditions_percent)
                  fd.append("instalment_conditions_desc", instalment_conditions_desc)
                  fd.append("instalment_conditions_date", selectedContractDate.value)
                  fd.append("instalment_conditions_mode_id", selectedContractMode.value)

                  xhttp.open("POST", `${constants.BASE_URL}/organ`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changeContract = () => {
            const {
                  organ_contract_id,
                  organ_contract_num,
                  organ_contract_clearing_day,
                  organ_contract_discount_max_amount,
                  organ_contract_discount_amount,
                  organ_contract_discount_percent,
                  organ_contract_date_start,
                  organ_contract_date,
                  organ_contract_date_end,
                  selectedFieldinsurance,
                  selectedInstamentRoundMode,
                  selectedOrgan,
                  selectedCompany,
                  organ_contract_deactive,
                  organ_contract_editable,
            } = this.state
            if (
                  selectedOrgan != "" &&
                  selectedFieldinsurance != "" &&
                  selectedInstamentRoundMode != "" &&
                  selectedCompany != "" &&
                  organ_contract_num != "" &&
                  organ_contract_clearing_day != "" &&
                  organ_contract_discount_max_amount != "" &&
                  organ_contract_discount_amount != "" &&
                  organ_contract_discount_percent != ""
            ) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getContract()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_contract")
                  fd.append("organ_contract_id", organ_contract_id)
                  fd.append("organ_contract_num", organ_contract_num)
                  fd.append("organ_contract_clearing_day", organ_contract_clearing_day)
                  fd.append("organ_contract_discount_max_amount", organ_contract_discount_max_amount)
                  fd.append("organ_contract_discount_amount", organ_contract_discount_amount)
                  fd.append("organ_contract_discount_percent", organ_contract_discount_percent)
                  if (organ_contract_date === "") {
                        fd.append("organ_contract_date", "")
                  } else {
                        fd.append(
                              "organ_contract_date",
                              Moment(JDate.toGregorian(organ_contract_date.year, organ_contract_date.month, organ_contract_date.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  if (organ_contract_date_start === "") {
                        fd.append("organ_contract_date_start", "")
                  } else {
                        fd.append(
                              "organ_contract_date_start",
                              Moment(
                                    JDate.toGregorian(organ_contract_date_start.year, organ_contract_date_start.month, organ_contract_date_start.day)
                              ).format("YYYY-MM-DD h:mm:ss")
                        )
                  }
                  if (organ_contract_date_end === "") {
                        fd.append("organ_contract_date_end", "")
                  } else {
                        fd.append(
                              "organ_contract_date_end",
                              Moment(
                                    JDate.toGregorian(organ_contract_date_end.year, organ_contract_date_end.month, organ_contract_date_end.day)
                              ).format("YYYY-MM-DD h:mm:ss")
                        )
                  }
                  fd.append("organ_contract_instalment_round_id", selectedInstamentRoundMode.value)
                  fd.append("organ_contract_fieldinsuranc_id", selectedFieldinsurance.value)
                  fd.append("organ_contract_organ_id", selectedOrgan.value)
                  fd.append("organ_contract_company_id", selectedCompany.value)
                  fd.append("organ_contract_editable", organ_contract_editable)
                  fd.append("organ_contract_deactive", organ_contract_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/organ`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterContract = () => {
            const { selectedFilterFieldinsurance, selectedFilterOrgan, selectedFilterCompany, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedFilterCompany.value === 0 || temparray[i].organ_contract_company_id === selectedFilterCompany.value) &&
                        (selectedFilterFieldinsurance.value === 0 ||
                              temparray[i].organ_contract_fieldinsuranc_id === selectedFilterFieldinsurance.value) &&
                        (selectedFilterOrgan.value === 0 || temparray[i].organ_contract_organ_id === selectedFilterOrgan.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      renderCustomInputEnd = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پایان"
                  value={
                        this.state.organ_contract_date_end.year
                              ? this.state.organ_contract_date_end.year +
                                "/" +
                                this.state.organ_contract_date_end.month +
                                "/" +
                                this.state.organ_contract_date_end.day
                              : ""
                  }
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyEnd}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputStart = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ شروع"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.organ_contract_date_start.year
                              ? this.state.organ_contract_date_start.year +
                                "/" +
                                this.state.organ_contract_date_start.month +
                                "/" +
                                this.state.organ_contract_date_start.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyStart}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInput = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ شروع"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.organ_contract_date.year
                              ? this.state.organ_contract_date.year +
                                "/" +
                                this.state.organ_contract_date.month +
                                "/" +
                                this.state.organ_contract_date.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDey}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      render() {
            const { classes } = this.props
            const {
                  optionInstalmentMode,
                  instalment_conditions_percent,
                  instalment_conditions_desc,
                  selectedContractDate,
                  selectedContractMode,
                  optionCompany,
                  installmentCondition,
                  optionFilterCompany,
                  optionOrgan,
                  optionFilterOrgan,
                  optionInstamentRoundMode,
                  optionFieldinsurance,
                  optionFilterFieldinsurance,
                  snackMode,
                  snackstr,
                  showSnack,
                  newContract,
                  organ_contract_id,
                  organ_contract_num,
                  organ_contract_clearing_day,
                  organ_contract_discount_max_amount,
                  organ_contract_discount_amount,
                  organ_contract_discount_percent,
                  organ_contract_date,
                  organ_contract_date_start,
                  organ_contract_date_end,
                  selectedOrgan,
                  selectedFilterOrgan,
                  selectedInstamentRoundMode,
                  selectedFieldinsurance,
                  selectedFilterFieldinsurance,
                  company_logo_url,
                  fieldinsurance_logo_url,
                  organ_logo,
                  selectedCompany,
                  selectedFilterCompany,
                  organ_contract_editable,
                  organ_contract_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قرارداد: " + organ_contract_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>
                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ انعقاد"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInput} // render a custom input
                                                                                    value={organ_contract_date}
                                                                                    onChange={this.setSelectedDay}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ شروع"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputStart} // render a custom input
                                                                                    value={organ_contract_date_start}
                                                                                    onChange={this.setSelectedDayStart}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پایان"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputEnd} // render a custom input
                                                                                    value={organ_contract_date_end}
                                                                                    onChange={this.setSelectedDayEnd}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="Remy Sharp" className={classes.large} src={organ_logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt="Remy Sharp"
                                                                              className={classes.large}
                                                                              src={fieldinsurance_logo_url}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="Remy Sharp" className={classes.large} src={company_logo_url} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on"> ارگان</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"ارگان"}
                                                                              value={selectedOrgan}
                                                                              onChange={this.handleOrgan}
                                                                              options={optionOrgan}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">رشته بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFieldinsurance}
                                                                              onChange={this.handleFieldinsurance}
                                                                              options={optionFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="َشماره قرارداد"
                                                                        handleInputt={this.handleChangeContractNum}
                                                                        value={organ_contract_num}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="روز تسویه در ماه"
                                                                        handleInputt={this.handleChangeDayClear}
                                                                        value={organ_contract_clearing_day}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on"> نوع محاسبه اقساط</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع محاسیه اقساط"}
                                                                              value={selectedInstamentRoundMode}
                                                                              onChange={this.handleInstamentRoundMode}
                                                                              options={optionInstamentRoundMode}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="تخفیف مبلغ ثابت"
                                                                        handleInputt={this.handleChangeDiscAmount}
                                                                        value={organ_contract_discount_amount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="درصد تخفیف گروهی"
                                                                        handleInputt={this.handleChangePercent}
                                                                        value={organ_contract_discount_percent}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="حداکثر مبلغ تخفیف"
                                                                        handleInputt={this.handleChangeDiscMax}
                                                                        value={organ_contract_discount_max_amount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={organ_contract_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت رشته بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={organ_contract_editable === "1" ? true : false}
                                                                                          onChange={this.handleChangeEditable}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="قابلیت ویرایش"
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  {newContract ? (
                                                                        <Button variant="outlined" color="primary" onClick={this.saveNewContract}>
                                                                              {"ثبت قرارداد جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button variant="outlined" color="primary" onClick={this.newContract}>
                                                                                    {"قرارداد جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changeContract}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قرارداد"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>
                                                            {newContract ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                            {newContract ? null : (
                                                                  <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                        {installmentCondition.map((condition, index) => (
                                                                              <OrganInstalmentConditoin
                                                                                    condition={condition}
                                                                                    props={this.props}
                                                                                    key={index}
                                                                              />
                                                                        ))}
                                                                  </Grid>
                                                            )}
                                                            {newContract ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Grid container spacing={3}>
                                                                              <Grid item xs={6} sm={2}>
                                                                                    <div>
                                                                                          <label className="on"> نوع</label>
                                                                                          <Select
                                                                                                isSearchable={true}
                                                                                                className="adapter-txtsize"
                                                                                                placeholder={"نوع تخفیف"}
                                                                                                value={selectedContractMode}
                                                                                                onChange={this.handleContractMode}
                                                                                                options={optionInstalmentMode}
                                                                                          />
                                                                                    </div>
                                                                              </Grid>

                                                                              <Grid item xs={6} sm={3}>
                                                                                    <div>
                                                                                          <label className="on"> زمان</label>
                                                                                          <Select
                                                                                                isSearchable={true}
                                                                                                className="adapter-txtsize"
                                                                                                placeholder={"زمان"}
                                                                                                value={selectedContractDate}
                                                                                                onChange={this.handleContractDate}
                                                                                                options={optionInstalmentDate}
                                                                                          />
                                                                                    </div>
                                                                              </Grid>

                                                                              <Grid item item xs={3} sm={2}>
                                                                                    <FloatingLabelInput
                                                                                          placeholder="درصد"
                                                                                          handleInputt={this.handleChangeConditionsPercent}
                                                                                          value={instalment_conditions_percent}
                                                                                    />
                                                                              </Grid>
                                                                              <Grid item item xs={5} sm={3}>
                                                                                    <FloatingLabelInput
                                                                                          placeholder="توضیحات"
                                                                                          handleInputt={this.handleChangeConditionsDesc}
                                                                                          value={instalment_conditions_desc}
                                                                                    />
                                                                              </Grid>

                                                                              <Grid item item xs={4} sm={2}>
                                                                                    <div style={{ width: "100%", textAlign: "left" }}>
                                                                                          <Fab
                                                                                                color="primary"
                                                                                                aria-label="add"
                                                                                                onClick={this.saveNewContractCondition}
                                                                                          >
                                                                                                <AddIcon />
                                                                                          </Fab>
                                                                                    </div>
                                                                              </Grid>
                                                                        </Grid>
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">ارگان </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={" ارگان"}
                                                                              value={selectedFilterOrgan}
                                                                              onChange={this.handleFilterOrgan}
                                                                              options={optionFilterOrgan}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">رشته بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFilterFieldinsurance}
                                                                              onChange={this.handleFilterFieldinsurance}
                                                                              options={optionFilterFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedFilterCompany}
                                                                              onChange={this.handleFilterCompany}
                                                                              options={optionFilterCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"organ_contract_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "organ_contract_id" ? order : false}
                                                                              >
                                                                                    {" آی دی تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_contract_id"}
                                                                                          direction={orderBy === "organ_contract_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_contract_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"organ_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {" نام ارگان "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_name"}
                                                                                          direction={orderBy === "organ_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" رشته بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_fa"}
                                                                                          direction={orderBy === "fieldinsurance_fa" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"instalment_num"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" تعداد استفاده "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "instalment_num"}
                                                                                          direction={orderBy === "instalment_num" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("instalment_num")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_contract_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قرارداد"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_contract_deactive"}
                                                                                          direction={
                                                                                                orderBy === "organ_contract_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_contract_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["organ_contract_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"organ_contract_id"} align={"center"}>
                                                                                                      {row["organ_contract_id"]}
                                                                                                </TableCell>
                                                                                                <TableCell key={"organ_name"} align={"center"}>
                                                                                                      {row["organ_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                      {row["fieldinsurance_fa"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                      {row["instalment_num"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"organ_contract_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["organ_contract_deactive"] === "1" ||
                                                                                                      row["organ_contract_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قرارداد را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteManagdiscount} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeOrganContrat)
